export const ACTION_ALLOCATION_GAP = `
  mutation ActionAllocationGap($input: ActionAllocationGapInput!) {
    actionAllocationGap(input: $input) {
      gapId
      status
      actionedAt
      actionedBy
      auditTrail
    }
  }
`
